const e="https://ats.nalgoo.com/api/v3";function r(n){const{baseUrl:o,organization:t}={baseUrl:e,organization:void 0,...n};return`${o.replace(/\/$/,"")}${t?`/organizations/${t}`:""}`}export{r as getBaseUrl};
